import * as Sentry from '@sentry/react';
import { getRuntimeContext } from './runtimeContext';

export function addCompleteContextToSentry(scope: Sentry.Scope): void {
  const token = localStorage.getItem('token');
  const runtimeContext = getRuntimeContext();
  
  // User authentication status
  if (token) {
    scope.setTag('userAuthenticated', 'true');
  } else {
    scope.setTag('userAuthenticated', 'false');
  }

  // Add runtime context (user, loan, modal)
  if (runtimeContext.user) {
    scope.setUser({
      id: runtimeContext.user.id,
      email: runtimeContext.user.email,
      username: runtimeContext.user.name
    });
  }

  if (runtimeContext.loan) {
    scope.setTag('loanId', runtimeContext.loan.id || 'none');
    scope.setContext('loan', runtimeContext.loan);
  }

  if (runtimeContext.modal) {
    scope.setTag('modalOpen', runtimeContext.modal.open ? (runtimeContext.modal.key || 'unknown') : 'none');
    scope.setContext('modal', runtimeContext.modal);
  }

  // Add browser context
  scope.setContext('browser', {
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,
    cookieEnabled: navigator.cookieEnabled
  });

  // Add URL context
  scope.setContext('url', {
    href: window.location.href,
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash
  });
}

